// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.MultipleFileUpload_dashboard__njcEY {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.MultipleFileUpload_dashboardContain__diOti {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_dashboardContain__diOti,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_dashboard__njcEY,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_cont2__AAQ9g {
  background-Color: #0f1824;
}

.MultipleFileUpload_top_header__Py0I0 .MultipleFileUpload_top_header_inner__ju1dR {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.MultipleFileUpload_cont2__AAQ9g {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.MultipleFileUpload_footer__BFGYL {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.MultipleFileUpload_bodythemelight__55up6 {
  background-color: #fff;
  padding-top: 90px;
}

.MultipleFileUpload_bodythemedark__nDQcj {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.MultipleFileUpload_headerthemelight__MXEfp {
  background-color: #fff;
}

.MultipleFileUpload_headerthemedark__zXZOl {
  background-color: #132337;
}

.MultipleFileUpload_top_header__Py0I0 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.MultipleFileUpload_menuthemelight__7BXMU {
  background-color: #fff;
}

.MultipleFileUpload_menuthemedark__rwp8J {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.MultipleFileUpload_menulinklight__wFWRF span {
  color: #666666 !important;
}

.MultipleFileUpload_menulinklight__wFWRF a {
  color: #CBCBCB !important;
}

.MultipleFileUpload_menulinklight__wFWRF:hover span, .MultipleFileUpload_menulinklight__wFWRF:hover a {
  color: #fff !important;
}

.MultipleFileUpload_menulinkdarkSelected__m3AHn {
  background-color: #1c2e45;
  color: #3b82f6;
}

.MultipleFileUpload_menuthemelight__7BXMU .MultipleFileUpload_menulinklightSelected__D7TQn {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.MultipleFileUpload_menulinkdark__Q6evH {
  color: #92afd3 !important;
}

.MultipleFileUpload_menulinklight__wFWRF:hover {
  color: #fff !important;
  background-color: #131F43;
}

.MultipleFileUpload_menulinklight__wFWRF .MultipleFileUpload_sub_arrow__syYFK svg path {
  stroke: #CBCBCB !important;
}

.MultipleFileUpload_menulinklight__wFWRF:hover .MultipleFileUpload_sub_arrow__syYFK svg path {
  stroke: #fff !important;
}

.MultipleFileUpload_menulinkdark__Q6evH .MultipleFileUpload_sub_arrow__syYFK svg path {
  stroke: #92afd3 !important;
}

.MultipleFileUpload_menulinkdark__Q6evH:hover .MultipleFileUpload_sub_arrow__syYFK svg path {
  stroke: #fff !important;
}

.MultipleFileUpload_menulinkdark__Q6evH:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.MultipleFileUpload_headinglight__EKOr6 {
  color: #60677e;
}

.MultipleFileUpload_headingdark__qVnHy {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.MultipleFileUpload_searchboxlight__RYStC {
  background-color: #fff;
  border: none;
}

.MultipleFileUpload_searchboxdark__ATbCI {
  background-color: #132337;
  color: #fff;
  border: none;
}

.MultipleFileUpload_searchboxdark__ATbCI::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.MultipleFileUpload_tableheadlight__IICSt {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.MultipleFileUpload_tableheadlight__IICSt th {
  color: #fff;
}

thead .MultipleFileUpload_tableheadlight__IICSt th:first-child,
thead .MultipleFileUpload_tableheaddark__uDmqr th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .MultipleFileUpload_tableheadlight__IICSt th:last-child,
thead .MultipleFileUpload_tableheaddark__uDmqr th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.MultipleFileUpload_table__tyXPa.MultipleFileUpload_table-borderless__aRKlG {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.MultipleFileUpload_tableheaddark__uDmqr {
  background-color: #132337;
  color: #fff;
}

.MultipleFileUpload_table-borderless__aRKlG tr:nth-child(even) {
  background-color: #F9FAFB;
}

.MultipleFileUpload_table-borderless__aRKlG .MultipleFileUpload_left-section__ZDD\\+g {
  padding-top: 10px;
}

.MultipleFileUpload_tablebodylight__\\+2kEF td,
.MultipleFileUpload_tablebodydark__OQqHb td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.MultipleFileUpload_tablebodylight__\\+2kEF {
  background-color: #fff;
}
.MultipleFileUpload_tablebodylight__\\+2kEF:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.MultipleFileUpload_tablebodydark__OQqHb {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.MultipleFileUpload_tablebodydark__OQqHb:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.MultipleFileUpload_paginationlight__suIRL {
  color: #60677e !important;
  font-size: 13px !important;
}

.MultipleFileUpload_paginationdark__z0Qbk {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.MultipleFileUpload_formthemelight__cDiE- {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.MultipleFileUpload_formthemedark__4dyQi {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.MultipleFileUpload_formthemedark__4dyQi ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.MultipleFileUpload_viewformlight__LkUc8 {
  background-color: #f3f6f9;
}

.MultipleFileUpload_permissionboxlight__pZ\\+zL {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.MultipleFileUpload_permissionboxdark__6GAme {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.MultipleFileUpload_errormsgclr__cG9yB {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.MultipleFileUpload_graphclrlight__n2Sr4 {
  background-color: #fff;
}

.MultipleFileUpload_graphclrdark__2W8YW {
  background-color: #132337;
}

/* 
Counter theme
*/
#MultipleFileUpload_card1bglight__C3eeB {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card1bgdark__A\\+GqH {
  background: #392f28;
}

#MultipleFileUpload_card2bglight__o-SOh {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card2bgdark__J\\+NKA {
  background: #1c3238;
}

#MultipleFileUpload_card3bglight__1SGnR {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card3bgdark__X-HBK {
  background: #3a2434;
}

#MultipleFileUpload_card4bglight__1\\+fiS {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card4bgdark__VCeGa {
  background: #2f264f;
}

#MultipleFileUpload_card1bgdark__A\\+GqH a, #MultipleFileUpload_card1bgdark__A\\+GqH p,
#MultipleFileUpload_card2bgdark__J\\+NKA a, #MultipleFileUpload_card2bgdark__J\\+NKA p,
#MultipleFileUpload_card3bgdark__X-HBK a, #MultipleFileUpload_card3bgdark__X-HBK p,
#MultipleFileUpload_card4bgdark__VCeGa a, #MultipleFileUpload_card4bgdark__VCeGa p {
  color: #fff;
}

/* 
Action button theme
*/
.MultipleFileUpload_actionbtnlight__toXE9 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.MultipleFileUpload_actionbtnlight__toXE9:hover {
  cursor: pointer;
}

.MultipleFileUpload_actionbtndark__tt7mR {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.MultipleFileUpload_profiledropdownlight__kVfq- {
  background-color: #fff;
}

.MultipleFileUpload_profiledropdowndark__XT0PU {
  background-color: #151521;
}

.MultipleFileUpload_settingsection__wRS3o #MultipleFileUpload_addform__TioPc.MultipleFileUpload_formthemedark__4dyQi .MultipleFileUpload_savebtn__E3H6v {
  background-color: #3b82f6;
  color: #fff;
}

#MultipleFileUpload_addform__TioPc.MultipleFileUpload_formthemedark__4dyQi .MultipleFileUpload_savebtn__E3H6v {
  background-color: #3b82f6;
  color: #fff;
}

.MultipleFileUpload_profile_conatiner__5MRJz {
  border-radius: 5px !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_ag-theme-alpine__dmLs- .MultipleFileUpload_ag-row__jVeoB {
  background: #000 !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_formbtn__IMFTv {
  background-color: #3b82f6;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_formbtn__IMFTv:hover {
  background-color: #2563eb;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_resetbtn__JOibc {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_resetbtn__JOibc:hover {
  background-color: #3b82f6;
}

.MultipleFileUpload_headingdark__qVnHy span {
  background-color: #132337;
}

.MultipleFileUpload_resetbtn__JOibc {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.MultipleFileUpload_resetbtn__JOibc:hover,
.MultipleFileUpload_resetbtn__JOibc:active,
.MultipleFileUpload_resetbtn__JOibc:focus {
  background-color: #131F43;
  color: #fff;
}

.MultipleFileUpload_addBtn__XN\\+ey {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.MultipleFileUpload_addbtnlight__dhpUT {
  background-color: #38A169;
}

.MultipleFileUpload_addbtndark__fnekb {
  background-color: #3b82f6;
}

.MultipleFileUpload_addbtndark__fnekb:hover {
  background-color: #2563eb;
}

.MultipleFileUpload_formthemedark__4dyQi label {
  color: #92afd3;
}

.MultipleFileUpload_addBtn__XN\\+ey svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.MultipleFileUpload_addBtn__XN\\+ey:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.MultipleFileUpload_cust_addBtn__mbp2P.MultipleFileUpload_addBtn__XN\\+ey svg {
  top: 2px;
}

.MultipleFileUpload_deleteBtn__Cthuu {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.MultipleFileUpload_deleteBtn__Cthuu {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.MultipleFileUpload_deleteBtn__Cthuu:active, .MultipleFileUpload_deleteBtn__Cthuu:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.MultipleFileUpload_deleteBtn__Cthuu svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.MultipleFileUpload_deleteBtn__Cthuu:hover,
.MultipleFileUpload_deleteBtn__Cthuu:active,
.MultipleFileUpload_deleteBtn__Cthuu:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.MultipleFileUpload_confirmBtn__Hu73W {
  background-color: #131F43;
}

.MultipleFileUpload_confirmBtn__Hu73W:hover,
.MultipleFileUpload_confirmBtn__Hu73W:active,
.MultipleFileUpload_confirmBtn__Hu73W:focus {
  background-color: #131F43;
}

.MultipleFileUpload_confirmBtn__Hu73W svg {
  top: 0;
}

.MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_modal-body__ZaTVw {
  padding: 25px;
  text-align: center;
}

.MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_delet_icon__rCiDT {
  margin-bottom: 11px;
}

.MultipleFileUpload_delPopContainer__mSgsh p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.MultipleFileUpload_arrowback__uE5pT svg {
  fill: #000;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_arrowback__uE5pT {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_arrowback__uE5pT svg {
  fill: #3b82f6;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_drpdwn_btn__FUvyA {
  background-color: #132337;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_empname__N-SE- {
  color: #92afd3 !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_navitemli__UiPob a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingsgeneral__7QqqL,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingslinks__tlKBP:hover {
  background-color: #3b82f6;
  color: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingslinks__tlKBP {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg {
  background-color: #1c2e45;
  color: #fff;
}

.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg ul li a,
.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg .MultipleFileUpload_dropdown_item__alfDZ,
.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg .MultipleFileUpload_dropdown_item__alfDZ h5 {
  color: #fff;
}

.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg ul li a:hover,
.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_dropdown_menu_contain__d-lJg .MultipleFileUpload_dropdown_item__alfDZ:hover {
  background-color: #132337;
  color: #fff;
}

.MultipleFileUpload_dropdown_item__alfDZ:active {
  background-color: #F5F6FA;
}

.MultipleFileUpload_profile_arrrow_dwn__GYoAL {
  stroke: #132337;
}

.MultipleFileUpload_headerthemedark__zXZOl .MultipleFileUpload_profile_arrrow_dwn__GYoAL {
  stroke: #fff;
}

.MultipleFileUpload_dateinputbox1__7BxhW input,
.MultipleFileUpload_dateinputbox1__7BxhW span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .MultipleFileUpload_tableheadlight__IICSt th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .MultipleFileUpload_dashboard__njcEY {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .MultipleFileUpload_cont2__AAQ9g {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .MultipleFileUpload_sectionright__PRP6W {
    float: unset !important;
  }
  .MultipleFileUpload_dashboard__njcEY {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .MultipleFileUpload_cont2__AAQ9g {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .MultipleFileUpload_bodythemelight__55up6, .MultipleFileUpload_bodythemedark__nDQcj {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .MultipleFileUpload_exer_modal_contain__hBMeo .MultipleFileUpload_modal-dialog__yUSUM {
    max-width: 1055px;
  }
  .MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_modal-dialog__yUSUM {
    max-width: 350px;
  }
}
.MultipleFileUpload_upload_btn__f3XcK {
  display: inline-block;
  border: 1px solid #ced4da;
  color: #60677e;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.MultipleFileUpload_uploaded_imgsection__hgzcC {
  width: 100px;
  height: 150px;
}

#MultipleFileUpload_uploaded_img__okx-t {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MultipleFileUpload_imgcancel_btn__9kFdj {
  border: none;
  font-size: 14px;
  padding: 5px 30px;
  background-color: #e2e3e7;
  margin-top: 5px;
  border-radius: 5px;
}
.MultipleFileUpload_imgcancel_btn__9kFdj:hover {
  background-color: #a9a9a9;
}

.MultipleFileUpload_close_icon_main__EdG41 {
  position: relative;
  margin-right: 1rem;
}

.MultipleFileUpload_close_icon__B8ggQ {
  position: absolute;
  right: 0px;
  border-radius: 0px 5px 0px 0px;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border: 1px solid #ced4da;
}

.MultipleFileUpload_formthemelight__cDiE- {
  box-shadow: none;
}

.MultipleFileUpload_formthemedark__4dyQi .MultipleFileUpload_upload_btn__f3XcK {
  border: 1px solid #92afd3 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/MultipleFileUpload/MultipleFileUpload.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAssBJ;;AAnsBA;EACI,YAAA;EACA,aAAA;AAssBJ;;AAnsBA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAssBJ;;AAnsBA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAssBJ;AApsBK;EACG,yBAAA;AAssBR;;AAlsBA;EACI,kBAAA;EACA,kBAAA;AAqsBJ;;AAnsBA;EACI,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAssBJ;;AAnsBA;EACI,gBAAA;AAssBJ;;AAnsBA;EACI,oCAAA;AAssBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n.upload_btn{\n    display: inline-block;\n    border: 1px solid #ced4da;\n    color: #60677e;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.uploaded_imgsection{\n    width: 100px;\n    height: 150px;\n}\n\n#uploaded_img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imgcancel_btn{\n    border: none;\n    font-size: 14px;\n    padding: 5px 30px;\n    background-color: #e2e3e7;\n    margin-top: 5px;\n    border-radius: 5px;\n\n     &:hover{\n        background-color: #a9a9a9;\n     }\n}\n\n.close_icon_main{\n    position: relative;\n    margin-right: 1rem;\n}\n.close_icon{\n    position: absolute;\n    right: 0px;\n    border-radius: 0px 5px 0px 0px;\n    width: 20px;\n    height: 20px;\n    background-color: #ffffff;\n    border: 1px solid #ced4da; \n}\n\n.formthemelight {\n    box-shadow: none; \n}\n\n.formthemedark .upload_btn{\n    border: 1px solid $dark-light-blue !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `MultipleFileUpload_dashboard__njcEY`,
	"dashboardContain": `MultipleFileUpload_dashboardContain__diOti`,
	"bodythemedark": `MultipleFileUpload_bodythemedark__nDQcj`,
	"cont2": `MultipleFileUpload_cont2__AAQ9g`,
	"top_header": `MultipleFileUpload_top_header__Py0I0`,
	"top_header_inner": `MultipleFileUpload_top_header_inner__ju1dR`,
	"footer": `MultipleFileUpload_footer__BFGYL`,
	"bodythemelight": `MultipleFileUpload_bodythemelight__55up6`,
	"headerthemelight": `MultipleFileUpload_headerthemelight__MXEfp`,
	"headerthemedark": `MultipleFileUpload_headerthemedark__zXZOl`,
	"menuthemelight": `MultipleFileUpload_menuthemelight__7BXMU`,
	"menuthemedark": `MultipleFileUpload_menuthemedark__rwp8J`,
	"menulinklight": `MultipleFileUpload_menulinklight__wFWRF`,
	"menulinkdarkSelected": `MultipleFileUpload_menulinkdarkSelected__m3AHn`,
	"menulinklightSelected": `MultipleFileUpload_menulinklightSelected__D7TQn`,
	"menulinkdark": `MultipleFileUpload_menulinkdark__Q6evH`,
	"sub_arrow": `MultipleFileUpload_sub_arrow__syYFK`,
	"headinglight": `MultipleFileUpload_headinglight__EKOr6`,
	"headingdark": `MultipleFileUpload_headingdark__qVnHy`,
	"searchboxlight": `MultipleFileUpload_searchboxlight__RYStC`,
	"searchboxdark": `MultipleFileUpload_searchboxdark__ATbCI`,
	"tableheadlight": `MultipleFileUpload_tableheadlight__IICSt`,
	"tableheaddark": `MultipleFileUpload_tableheaddark__uDmqr`,
	"table": `MultipleFileUpload_table__tyXPa`,
	"table-borderless": `MultipleFileUpload_table-borderless__aRKlG`,
	"left-section": `MultipleFileUpload_left-section__ZDD+g`,
	"tablebodylight": `MultipleFileUpload_tablebodylight__+2kEF`,
	"tablebodydark": `MultipleFileUpload_tablebodydark__OQqHb`,
	"paginationlight": `MultipleFileUpload_paginationlight__suIRL`,
	"paginationdark": `MultipleFileUpload_paginationdark__z0Qbk`,
	"formthemelight": `MultipleFileUpload_formthemelight__cDiE-`,
	"formthemedark": `MultipleFileUpload_formthemedark__4dyQi`,
	"viewformlight": `MultipleFileUpload_viewformlight__LkUc8`,
	"permissionboxlight": `MultipleFileUpload_permissionboxlight__pZ+zL`,
	"permissionboxdark": `MultipleFileUpload_permissionboxdark__6GAme`,
	"errormsgclr": `MultipleFileUpload_errormsgclr__cG9yB`,
	"graphclrlight": `MultipleFileUpload_graphclrlight__n2Sr4`,
	"graphclrdark": `MultipleFileUpload_graphclrdark__2W8YW`,
	"card1bglight": `MultipleFileUpload_card1bglight__C3eeB`,
	"card1bgdark": `MultipleFileUpload_card1bgdark__A+GqH`,
	"card2bglight": `MultipleFileUpload_card2bglight__o-SOh`,
	"card2bgdark": `MultipleFileUpload_card2bgdark__J+NKA`,
	"card3bglight": `MultipleFileUpload_card3bglight__1SGnR`,
	"card3bgdark": `MultipleFileUpload_card3bgdark__X-HBK`,
	"card4bglight": `MultipleFileUpload_card4bglight__1+fiS`,
	"card4bgdark": `MultipleFileUpload_card4bgdark__VCeGa`,
	"actionbtnlight": `MultipleFileUpload_actionbtnlight__toXE9`,
	"actionbtndark": `MultipleFileUpload_actionbtndark__tt7mR`,
	"profiledropdownlight": `MultipleFileUpload_profiledropdownlight__kVfq-`,
	"profiledropdowndark": `MultipleFileUpload_profiledropdowndark__XT0PU`,
	"settingsection": `MultipleFileUpload_settingsection__wRS3o`,
	"addform": `MultipleFileUpload_addform__TioPc`,
	"savebtn": `MultipleFileUpload_savebtn__E3H6v`,
	"profile_conatiner": `MultipleFileUpload_profile_conatiner__5MRJz`,
	"ag-theme-alpine": `MultipleFileUpload_ag-theme-alpine__dmLs-`,
	"ag-row": `MultipleFileUpload_ag-row__jVeoB`,
	"formbtn": `MultipleFileUpload_formbtn__IMFTv`,
	"resetbtn": `MultipleFileUpload_resetbtn__JOibc`,
	"addBtn": `MultipleFileUpload_addBtn__XN+ey`,
	"addbtnlight": `MultipleFileUpload_addbtnlight__dhpUT`,
	"addbtndark": `MultipleFileUpload_addbtndark__fnekb`,
	"cust_addBtn": `MultipleFileUpload_cust_addBtn__mbp2P`,
	"deleteBtn": `MultipleFileUpload_deleteBtn__Cthuu`,
	"confirmBtn": `MultipleFileUpload_confirmBtn__Hu73W`,
	"delPopContainer": `MultipleFileUpload_delPopContainer__mSgsh`,
	"modal-body": `MultipleFileUpload_modal-body__ZaTVw`,
	"delet_icon": `MultipleFileUpload_delet_icon__rCiDT`,
	"arrowback": `MultipleFileUpload_arrowback__uE5pT`,
	"drpdwn_btn": `MultipleFileUpload_drpdwn_btn__FUvyA`,
	"empname": `MultipleFileUpload_empname__N-SE-`,
	"navitemli": `MultipleFileUpload_navitemli__UiPob`,
	"tabnavli": `MultipleFileUpload_tabnavli__y6GNL`,
	"settingsgeneral": `MultipleFileUpload_settingsgeneral__7QqqL`,
	"settingslinks": `MultipleFileUpload_settingslinks__tlKBP`,
	"dropdown_menu_contain": `MultipleFileUpload_dropdown_menu_contain__d-lJg`,
	"dropdown_item": `MultipleFileUpload_dropdown_item__alfDZ`,
	"profile_arrrow_dwn": `MultipleFileUpload_profile_arrrow_dwn__GYoAL`,
	"dateinputbox1": `MultipleFileUpload_dateinputbox1__7BxhW`,
	"sectionright": `MultipleFileUpload_sectionright__PRP6W`,
	"exer_modal_contain": `MultipleFileUpload_exer_modal_contain__hBMeo`,
	"modal-dialog": `MultipleFileUpload_modal-dialog__yUSUM`,
	"upload_btn": `MultipleFileUpload_upload_btn__f3XcK`,
	"uploaded_imgsection": `MultipleFileUpload_uploaded_imgsection__hgzcC`,
	"uploaded_img": `MultipleFileUpload_uploaded_img__okx-t`,
	"imgcancel_btn": `MultipleFileUpload_imgcancel_btn__9kFdj`,
	"close_icon_main": `MultipleFileUpload_close_icon_main__EdG41`,
	"close_icon": `MultipleFileUpload_close_icon__B8ggQ`
};
export default ___CSS_LOADER_EXPORT___;
